import { createStyles, makeStyles, Theme } from '@material-ui/core';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1),
        boxSizing: 'border-box',
      },
      loadingContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      },
      subTitle: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 16,
        color: sicrediColor.secondarySicrediDarker,
        padding: theme.spacing(1),
      },
      nomPauta: {
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 600,
        fontSize: 18,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        padding: theme.spacing(1),
      },
      itemHeader: {
        borderRadius: 4,
        backgroundColor: sicrediColor.secondarySicrediLightest,
        margin: theme.spacing(2, 1),
        boxSizing: 'border-box',
        width: 'calc(100% - 16px)',
      },
      itemHead: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '22px',
        color: sicrediColor.secondarySicrediDarker,
        padding: theme.spacing(1),
        textAlign: 'center',
      },
      itemHeadLeft: {
        textAlign: 'left',
      },
      item: {
        borderRadius: 4,
        width: 'calc(100% - 16px)',
        backgroundColor: sicrediColor.secondarySicrediLightest,
        margin: theme.spacing(2, 1),
        boxSizing: 'border-box',
      },
      itemText: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 16,
        lineHeight: '24px',
        color: sicrediColor.secondarySicrediDarker,
        padding: theme.spacing(2, 1),
        textAlign: 'center',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: sicrediColor.secondarySicrediLight,
      },
      itemTextLeft: {
        textAlign: 'left',
      },
    }),
  { name: 'InconsistenciaVotosModal' }
);
